const selectElements = document.getElementsByClassName("dynamic-variant-input-wrap");
 
Array.from(selectElements).forEach((selectElement) => {
    selectElement.addEventListener("click", (event) => {
        var oldVariant = document.getElementsByClassName("axt-cp-custom")[0].getAttribute("axt-cp-variant-id");
 
        setTimeout(() => {
            var variantId = document.querySelector('[name="id"]').value;
            var customElement = document.getElementsByClassName("axt-cp-custom")[0];
 
            customElement.classList.add(variantId);
            customElement.classList.remove(oldVariant); 
            customElement.setAttribute("axt-cp-variant-id", variantId);
        }, 700);
    });
});